export const SCREEN_TITLES = {
  CLASSIFICATION_REPORT: "分類数値レポート",
  AGGREGATION_CORRECTION_REPORT: "集計修正レポート",
};

export const COMPONENT_NAME = {
  REPORT_CONDITION: "ReportCondition",
};
